import { useState } from "react";
// import { BrowserView, MobileView } from "react-device-detect";
import {
  Alert,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Link,
} from "@mui/material";
import { JobsAPI } from "../apis/jobsApi";

import constants from "../static/constants.json";

import CameraDrawer from "./CameraDrawer";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useDispatch } from "react-redux";
import { editJob } from "../redux/jobSlice";
type JobDialogProps = {
  job: any;
  open: boolean;
  handleClose: () => void;
};

const JobCompleteDialog = ({ job, open, handleClose }: JobDialogProps) => {
  const dispatch = useDispatch();
  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState<JSX.Element | null>(null);
  const [images, setImages] = useState([] as string[]);

  const [showDrawer, setShowDrawer] = useState(false);

  const closeDialog = () => {
    setImages([]);
    handleClose();
  };

  const completeJob = async () => {
    const body = {
      eventTypeId: constants.eventType.completed,
      images,
    } as any;

    try {
      const j = await JobsAPI.createJobEvent(job.id, body);
      dispatch(editJob(j));
      setMsg(
        <>
          Job completed {" "}
          <Link
            style={{ color: "#ffffff", textDecoration: "underline" }}
            href={`/assignments/${job.id}`}
          >
            Click to view
          </Link>{" "}
        </>
      );
      setShowMsg(true);
      closeDialog();
    } catch (e) {}
  };

  const addPhoto = (img: string) => {
    images.push(img);
    setImages(images);
  };

  const getImagesContent = () => {
    return (
      <Carousel>
        {images.map((i: string) => {
          return (
            <div>
              <img src={i} alt={`image_${i}`} />
              {/* <p className="legend">Legend 1</p> */}
            </div>
          );
        })}
      </Carousel>
    );
  };

  return (
    <>
      <Snackbar
        open={showMsg}
        autoHideDuration={6000}
        onClose={() => setShowMsg(false)}
        message={msg}
      >
        <Alert
          onClose={() => setShowMsg(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <CameraDrawer
        open={showDrawer}
        onClose={() => {
          setShowDrawer(false);
        }}
        onPhotoTaken={(photo: string) => {
          addPhoto(photo);
          setShowDrawer(false);
        }}
      />
      <Dialog open={open} onClose={closeDialog}>
        <DialogTitle>{"Completing Job"}</DialogTitle>
        <DialogContent>
          <Alert severity="warning" icon={null}>
            You must add after photos to verify your hard work!
          </Alert>
          {getImagesContent()}
          {/* <Carousel>
            <div>
              <img src="https://static.vecteezy.com/system/resources/previews/024/722/367/non_2x/fish-with-ai-generated-free-png.png" />
              <p className="legend">Legend 1</p>
            </div>
            <div>
              <img src="https://www.scubadiving.com/sites/default/files/styles/655_1x_/public/trevor/Fish_Noheaphotos_shutterstock_1332341678.jpg?itok=ZjaSvmKI" />
              <p className="legend">Legend 2</p>
            </div>
          </Carousel> */}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setShowDrawer(true)}>
            Add Photo
          </Button>
          <Button
            disabled={images.length === 0}
            onClick={() => completeJob()}
            variant="contained"
          >
            Complete Job
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default JobCompleteDialog;
